import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { utils, Clinic } from 'kb-shared';
import { Title, YellowButton, FlexWrapper, OutlineButton } from './styled-components';
import LocationDetails from '../components/LocationDetails';
const { cycleVisitId, initialCycleVisitId } = utils;

const ordinals = [
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
  'sixth',
  'seventh',
  'eighth',
  'ninth',
  'tenth',
  'eleventh',
  'twelfth',
  'thirteenth',
  'fourteenth',
  'fifteenth'
];

interface Props {
  id?: string | number;
  idx: number;
  locationDetails?: Clinic;
  showResults?: boolean;
}

const CycleAppointment = ({ id, idx, locationDetails, showResults }: Props) => {
  const history = useHistory();

  const firstVisitId = initialCycleVisitId(process.env.REACT_APP_ENV);
  const subsequentVisitIds = cycleVisitId(process.env.REACT_APP_ENV);
  const apptTypeId = idx === 0 ? firstVisitId : subsequentVisitIds;

  return (
    <ContentWrapper>
      <RightContent>
        <FlexWrapper>
          <CycleTitle>Your {ordinals[idx]} cycle visit</CycleTitle>
          {!id && (
            <RightYellowButton
              onClick={() => history.push(`/book?step=location&appointment_id=${apptTypeId}`)}
            >
              Schedule Appointment
            </RightYellowButton>
          )}
        </FlexWrapper>
        {locationDetails && (
          <FlexWrapper>
            <LocationDetails location={locationDetails} />
            {showResults && (
              <RightOutlineButton onClick={() => history.push(`/results`)}>
                View Results
              </RightOutlineButton>
            )}
          </FlexWrapper>
        )}
      </RightContent>
    </ContentWrapper>
  );
};

export default CycleAppointment;

const ContentWrapper = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.KBNight};
  cursor: default;
  display: flex;
  margin: 2px 0px;
  position: relative;

  :last-of-type {
    margin-bottom: 28px;
  }
`;

const RightContent = styled.div`
  width: 100%;
`;

const CycleTitle = styled(Title)`
  align-items: baseline;
`;

const RightYellowButton = styled(YellowButton)`
  right: 24px;
  width: min-content;
  white-space: nowrap;
`;

const RightOutlineButton = styled(OutlineButton)`
  right: 24px;
  width: min-content;
  height: min-content;
  white-space: nowrap;
  margin-top: 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    margin-top: 0px;
  }
`;
